import { UploadFiles } from '~components/generic/elements/Upload/UploadFiles';
import entityContainerConnector from '~components/generic/entityContainerConnector';

export default entityContainerConnector(UploadFiles);
